// removed by extract-text-webpack-plugin
module.exports = {"ant-modal-wrap":"ant-modal-wrap","push-modal-wrap":"push-modal-wrap","push-modal":"push-modal","text-red":"text-red"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/arrayPgt/haplotypeReport/containers/pushModal.scss
// module id = 1411
// module chunks = 0